import { Controller } from "stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {

  initialize() {
    const styles = getComputedStyle(this.element);

    this.slider = new Splide(this.element, {
      gap: styles.getPropertyValue('--gap'),
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: true,
      speed: 600,
      waitForTransition: false
    }).mount();

    // Lets splide_arrows hide the arrows when there is only one slide
    document.dispatchEvent(new CustomEvent('NewSplideInstance', { detail: { 'splideElement': this.element } }));
  }
};
